import * as React from "react";

import * as sc from "./CaptionContainer.sc";

interface CaptionContainerProps {
    caption?: string;
    isVisible?: boolean;
}

const CaptionContainer: React.FunctionComponent<CaptionContainerProps> = ({ children, caption, isVisible = true }) => {
    return (
        <sc.Root isVisible={isVisible}>
            <sc.Container>{caption && <sc.Caption>{caption}</sc.Caption>}</sc.Container>
            {children}
        </sc.Root>
    );
};

export default CaptionContainer;
